/* global d3: true; */
import pym from 'pym.js';
import throttle from 'lodash.throttle';


const pymChild = new pym.Child();

const popRaceListItems = document.querySelectorAll('#pop-race-list li');

const data = [
  {
    group: 'State Population',
    black: 33,
    white: 57.9,
    other: 9.1,
    source: 'Source: U.S. Census 2022; Note: “All other races and ethnicities” includes people identifying as Native or Indigenous American, Asian, Pacific Islander, Multiracial, or ethnically Latinx.',
    left: '50%',
    top: '95%',
  },
  {
    group: 'District Attorneys',
    black: 11.9,
    white: 88.1,
    source: 'Source: Louisiana District Attorneys Association Roster 2022',
    left: '-9999px',
    top: '-9999px',
  },
  {
    group: 'Sheriffs',
    black: 6.3,
    white: 93.7,
    source: 'Source: Louisiana Sheriffs’ Association Directory 2022',
    left: '-9999px',
    top: '-9999px',
  },
  {
    group: 'Prisons',
    black: 64.7,
    white: 34.9,
    other: 0.4,
    source: 'Source: Louisiana Department of Public Safety & Corrections, Oct 2022; Note: Race identification in prison data is determined by the LA DPS&C, and likely undercounts people not identifying as Black or white.',
    left: '73%',
    top: '40%',
  },
  {
    group: 'Jails',
    black: 57.4,
    white: 37.8,
    other: 4.8,
    source: 'Source: Bureau of Justice Statistics, Census of Jails, 2019; Note: “All other races” includes people identifying as Native or Indigenous American, Asian, Pacific Islander, Multiracial, or ethnically Latinx.',
    left: '73%',
    top: '55%',
  },
];

let svg;
let arc;
let pie;

// grabbing initial window width
let windowWidth = window.innerWidth;

let currentData = [57.9, 9.1, 33];

function drawChart(chartData) {
  const colors = ['red', 'rgb(215,215,215)', '#4970ce'];

  const containerWidth = document.querySelector('.pie-container').offsetWidth;
  const containerHeight = containerWidth * 0.6;

  const width = containerWidth;
  const height = containerHeight;
  const radius = Math.min(width, height) / 2;

  arc = d3.arc()
    .outerRadius(radius - 10)
    .innerRadius(0);

  pie = d3.pie()
    .startAngle(-0.75)
    .sort(null)
    .value(d => d);

  svg = d3.select('#pop-race-pie').html('').append('svg')
    .attr('width', width)
    .attr('height', height)
    .append('g')
    .attr('transform', `translate(${width / 2}, ${height / 2})`);

  const path = svg.selectAll('path')
    .data(pie(chartData))
    .enter()
    .append('g')
    .append('path')
    .attr('d', arc)
    .attr('fill', (d, i) => (i === 0 ? 'url(#diagonal-stripe-1)' : colors[i]))
    .style('stroke', 'white')
    .style('stroke-width', 2);

  d3.select('#white__value').text(`${chartData[0]}%`);
  d3.select('#other__value').text(`${chartData[1]}%`);
  d3.select('#black__value').text(`${chartData[2]}%`);

  pymChild.sendHeight();
}

function updateChart(newData) {
  const path = svg.selectAll('path')
    .data(pie(newData))
    .transition()
    .duration(0)
    .attr('d', arc);

  d3.select('#white__value').text(`${newData[0]}%`);
  d3.select('#other__value').text(`${newData[1]}%`);
  d3.select('#black__value').text(`${newData[2]}%`);

  pymChild.sendHeight();
}

drawChart(currentData);

popRaceListItems.forEach((li) => {
  li.addEventListener('click', (e) => {
    const currentActive = document.querySelector('#pop-race-list li.active');
    currentActive.classList.remove('active');
    e.target.classList.add('active');

    const targetGroup = e.target.innerText;
    const selectedData = data.find(d => d.group === targetGroup);
    const newData = [selectedData.white, (selectedData.other === undefined ? 0 : selectedData.other), selectedData.black];
    updateChart(newData);
    currentData = newData;

    d3.select('#source_line')
      .text(selectedData.source)
      .attr('class', () => (targetGroup === 'State Population' ? 'source extra-margin' : 'source'));

    d3.select('#other__label').style('left', selectedData.left);
    d3.select('#other__label').style('top', selectedData.top);
    pymChild.sendHeight();
  });
});

// listen for window resizes, and if the width changes,
// redraw the graphic. Upon redraw, the graphic svg will be
// cleared, new width for the parent element will be pulled, and
// that new width will serve as the new base width of the graphic
// we also throttle this resize event listener so as to reduce the number
// of redraws per window resize
window.addEventListener('resize', throttle(() => {
  const newWindowWidth = window.innerWidth;

  if (newWindowWidth !== windowWidth) {
    drawChart(currentData);
    windowWidth = newWindowWidth;

    pymChild.sendHeight();
  }
}), 250);


pymChild.sendHeight();
